import {
  ActionReducerMap, createAction,
  createFeatureSelector,
  MetaReducer
} from '@ngrx/store';

import {initStateFromLocalStorage} from './meta-reducers/init-state-from-local-storage.reducer';
import {routerReducer, RouterReducerState} from '@ngrx/router-store';
import {RouterStateUrl} from './router/router.state';
import {authReducer, AuthState} from './stores/auth/reducers/auth.reducer';

export const reducers: ActionReducerMap<AppState> = {
  router: routerReducer,
  auth: authReducer
};

export const metaReducers: MetaReducer<AppState>[] = [
  initStateFromLocalStorage
];

export const selectRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');
export const selectAuthState = createFeatureSelector<AuthState>('auth');

export interface AppState {
  router: RouterReducerState<RouterStateUrl>;
  auth: AuthState;
}

export const DoNothingAction = createAction(
  '[App] DoNothing'
);

